import React from 'react';
import { FormLabel as FormLabelNew } from './FormLabel';
import { convertOldFormLabelProps } from './converter.old';
import type { OldFormLabelProps } from './converter.old';

export type FormLabelProps = OldFormLabelProps;

export const FormLabel = React.forwardRef<HTMLLabelElement, FormLabelProps>((props, ref) => {
  return <FormLabelNew {...convertOldFormLabelProps(props)} ref={ref} />;
});
